import { ToneAndChildren } from '@/utils/helpers';
import { ToneCountWithUser } from '@/utils/helpers';
import PrivateWarning from '../PrivateWarning/PrivateWarning';

export const ToneCardActions = ({ tone }: { tone: ToneCountWithUser }) => {
  return (
    <div className="hidden sm:block">
      <PrivateWarning tone={tone as unknown as ToneAndChildren} type="icon" />
    </div>
  );
};
